import React, { Component } from 'react'

const initData = {
    heading: "See What other Clients are saying.",
    // content: "Streamlining different processes and workflows by using user access control Onebook prompts efficiency and productivity levels of an organization, and reduces operating costs."
}

const person = [
    {
        id:1,
        name:  "Benjamin",
        designation:  "Co-Founder",
        "image": "/img/Benjamin.png" ,
        "openion": "FieldForce revolutionized our operations with their innovative software. Their dedication to our success is truly commendable. Highly recommended!.",
    },
    {
        id:2,
        name:  "Sohaib Hassan ",
        designation:  "Co-Founder",
        image: "/img/Shoiab_Hassan.png" ,
        openion: "Your automated system transformed our textile operations. It's efficient, reliable, and user-friendly. Thanks for revolutionizing our workflow.",
    },
    {
        id:3,
        name:  "Sarah Smith",
        designation:  "Co-Founder",
        image: "/img/Sarah_Smith.png" ,
        openion: "Streamline Innovations experienced a digital transformation like no other with FieldForce. Their customized software solutions continue to drive our progress.",
    },
    {
        id:4,
        name:  "Emily Johnson",
        designation:  "Co-Founder",
        image: "/img/Emily_Johnson.png" ,
        openion: "Precision Manufacturing's efficiency skyrocketed with FieldForce. Their support and adaptability are top-notch, ensuring our continued success.",
    }
]

class Testimonial extends Component {

    state = {
        data: {},
        person: []
    }

    componentDidMount(){

        // you can also make this by api call
        // axios.get(`${BASE_URL}`)
        //     .then(res => {
        //         this.setState({
        //             data: res.data,
        //             person: res.data.person
        //         })
        //         console.log(this.state)
        //     })
        //     .catch(err => console.log(err))

            this.setState({
                data: initData,
                person: person
            })
    }

    render() {
        return (
            <section className="testimonial-section bg-secondary ptb-90">
                <div className="testimonial-wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="section-heading text-center">
                                    <h3>{this.state.data.heading}</h3>
                                    <p>{this.state.data.content}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="owl-carousel owl-theme testimonial-slider">
                                    
                                    {this.state.person.map((item, idx) => {
                                        return(
                                            <div key={`t_${idx}`} className="item">
                                                <div className="single-testimonial-item">
                                                    <span className="blockquote-icon"><i className="fa fa-quote-left"></i></span>
                                                    <div className="testimonial-content">
                                                        <p>{item.openion}</p>
                                                    </div>
                                                    <div className="testimonial-author">
                                                        <img src={item.image} alt="" />
                                                        <div className="testimonial-author-info">
                                                            <h6>{item.name}</h6>
                                                            <span>{item.designation}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )    
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Testimonial